import { QueryParamConfig } from 'use-query-params'
import { SuiteName } from '@signifyd/cypress'

const SUITES = ['fe', 'qe'] as const satisfies readonly SuiteName[]

export const DEFAULT_SUITE: SuiteName = 'fe'

const isSuiteName = (value: string): value is SuiteName =>
  (SUITES as readonly string[]).includes(value)

export const SuiteParam: QueryParamConfig<SuiteName> = {
  encode: (suite) => suite,
  decode: (raw) => {
    const value = (Array.isArray(raw) ? raw[0] : raw)?.toLowerCase()

    return value && isSuiteName(value) ? value : DEFAULT_SUITE
  },
}

export const getSuiteLabel = (suite: SuiteName): Uppercase<SuiteName> =>
  suite.toUpperCase() as Uppercase<SuiteName>
